export default __webpack_public_path__ + "assets/cbc5c32ca8b460b1148df0f7ab305a47.jpeg";